<template>
  <div class="tag d-inline-block color-sachlich-white bg-expinet-blue px-2 rounded-pill">
    {{ item.listDisplay }}
    <span
      class="close ms-1"
      @click="closeHandler"
    ><i class="fa fa-times" /></span>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    item:  { type: Object, default: null },
    close: { type: Function, default: () => console.log('close not implemented') }, // eslint-disable-line no-console
  },

  methods: {
    closeHandler() {
      this.close(this.item)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.tag {
  font-size: $default-font-size;
  margin: 2px 3px 2px 0;
  cursor: default;

  &:hover {
    color: $color-aida-white;
    background-color: $color-expinet-blue-h;
  }
}

.close {
  cursor: pointer;
}
</style>
